import classNames from 'classnames/bind';
import { Box } from 'shared';

import styles from 'features/chat/components/Chat.module.css';

const cx = classNames.bind(styles);

export const ChatMessageBubble = ({
  incoming,
  isMorpheus,
  children,
}: {
  incoming: boolean;
  isMorpheus: boolean;
  children: React.ReactNode;
}) => (
  <Box
    className={cx(
      'chat__message',
      isMorpheus
        ? 'chat__message--morpheus'
        : incoming
        ? 'chat__message--incoming'
        : 'chat__message--outgoing'
    )}
  >
    {children}
  </Box>
);
